import {
  Button,
  Divider,
  FormControl,
  Grid,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from "react";
import { FID_LOGO } from "../DrawerAppBar";
import { Link, useNavigate } from "react-router-dom";
import AuthService from "../../../service/AuthService";
import useToast from "../../../hooks/useToast";
import { isValidEmail } from "../../../Helpers/utilsHelper";
import PermIdentityOutlinedIcon from "@material-ui/icons/PermIdentityOutlined";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import useConfirm from "../../../hooks/useConfirm";
import useNotification from "../../../hooks/useNotification";
import { TYPE_NOTIFICATION } from "../shares/NotificationBull";
import IndicationCreationCompte from "../shares/extra/IndicationCreationCompte";

const LoginPage = () => {
  const { Toast, showToast } = useToast();
  const [loading, setloading] = useState(false);
  const [submited, setSubmitted] = useState(false);
  const [authData, setAuthData] = useState({ email: "", password: "" });
  const [message, setMessage] = useState("");
  const { DialogComponent, openConfirmDialog } = useConfirm();
  const { NotificationComponent, showNotification } = useNotification();
  const navigate = useNavigate();
  const [formError, setFormError] = useState({
    mailError: null,
    passwordError: null,
  });
  const isSubmitted = () => {
    return submited;
  };

  const handleActivateAccount = () => {
    openConfirmDialog(
      "Votre compte n'est pas encore activé",
      "Voullez vous activer votre compte?",
      () => handleResendActivationMail(),
      true
    );
  };

  const handleResendActivationMail = () => {
    AuthService.resendActivationLink(authData).then((res) => {
      if (res && res.success) {
        showNotification(
          "Information",
          res.message,
          TYPE_NOTIFICATION.INFO,
          () => {}
        );
      }
    });
  };

  const handleSubmit = () => {
    setSubmitted(true);
    setloading(true);
    const isValid = checkDataValidation();
    if (isValid) {
      AuthService.login(authData)
        .then((res) => {
          // alert(res);
          if (res && res.success) {
            setFormError({ mailError: null, passwordError: null });
            navigate("/");
          } else {
            setMessage(res.message);
            if (res.message === "Votre compte n'est pas encore activé") {
              handleActivateAccount();
            }
          }
        })
        .finally((res) => {
          setloading(false);
          // console.log(res);
        });
    } else {
      setloading(false);
    }
  };

  const checkDataValidation = () => {
    if (!isValidEmail(authData.email)) {
      setFormError({
        ...formError,
        mailError: "Veuillez entrer un email valide",
      });
      return false;
    } else {
      setFormError({ ...formError, mailError: null });
      return true;
    }
  };

  useEffect(() => {
    if (AuthService.isConnected()) {
      navigate("/");
    }
    checkDataValidation();
  }, []);

  const handleGoToForgotPasswordPage = () => {
    navigate("/forgot-password");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAuthData({ ...authData, [name]: value });
    if (name === "email") {
      setFormError({
        ...formError,
        mailError: isValidEmail(value)
          ? null
          : "Veuillez entrer un email valide",
      });
    } else if (name === "password") {
      setFormError({
        ...formError,
        passwordError:
          value.length >= 6
            ? null
            : "Le mot de passe doit contenir au moins 6 caractères",
      });
    }
  };
  return (
    <>
      <NotificationComponent />
      <DialogComponent />
      <Toast />
      <Grid
        item
        md={4}
        xs={10}
        sm={6}
        lg={4}
        xl={3}
        display={"flex"}
        flexDirection={"column"}
        m={3}
      >
        <Grid mb={5}>
          <IndicationCreationCompte />
        </Grid>
        <Paper sx={{ p: 3 }}>
          <Grid item xs={12} display={"flex"} justifyContent="center">
            {FID_LOGO}
          </Grid>
          <h3>Connectez-vous</h3>
          <Grid
            container
            display={"flex"}
            flexDirection={"column"}
            justifyContent="center"
            alignItems="center"
          >
            <Grid container display={"flex"} flexDirection={"column"}>
              <FormControl fullWidth>
                <label>Nom d'utilisateur *</label>
                <TextField
                  id="email"
                  name="email"
                  size="small"
                  placeholder="Username"
                  fullWidth
                  onChange={(e) => handleChange(e)}
                  value={authData.email}
                  error={formError.mailError && isSubmitted()}
                  helperText={
                    formError.mailError && isSubmitted()
                      ? formError.mailError
                      : null
                  }
                  aria-describedby="username_helper"
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <PermIdentityOutlinedIcon />
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              </FormControl>
              <FormControl fullWidth sx={{ mt: 2 }}>
                <label>Mot de passe *</label>
                <TextField
                  id="password"
                  name="password"
                  type="password"
                  size="small"
                  placeholder="Mot de passe"
                  fullWidth
                  onChange={(e) => handleChange(e)}
                  value={authData.password}
                  error={message !== "" && isSubmitted()}
                  helperText={message}
                  aria-describedby="pwd_helper"
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockOutlinedIcon />
                        </InputAdornment>
                      ),
                    },
                  }}
                />
                {/* <FormHelperText id="pwd_helper">{message}</FormHelperText> */}
              </FormControl>
            </Grid>
            <Grid
              item
              display={"flex"}
              justifyContent="center"
              alignItems="center"
              pt={5}
              width={"100%"}
            >
              <LoadingButton
                fullWidth
                loading={loading}
                variant="contained"
                type="submit"
                onClick={handleSubmit}
              >
                Se connecter
              </LoadingButton>
            </Grid>
            <Grid
              item
              xs={12}
              mt={2}
              width={"100%"}
              justifyContent={"center"}
              display={"flex"}
              flexDirection={"column"}
            >
              <Button
                onClick={handleGoToForgotPasswordPage}
                variant="body2"
                underline="hover"
              >
                Mot de passe oublié ?
              </Button>
              <Divider sx={{ my: 2 }}>
                <Typography variant="body1" color="text.secondary">
                  ou
                </Typography>
              </Divider>
            </Grid>
            <Grid item xs={12} width={"100%"}>
              <Link to="/registration" color="secondary" underline="hover">
                <Button variant="outlined" color="secondary" fullWidth>
                  Creer un compte
                </Button>
              </Link>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>
  );
};

export default LoginPage;
